import { useContext, useState, useEffect } from 'react';
import {
  array, func, object, string,
} from 'prop-types';
import { Select } from 'antd';

import {
  formatShipmentCost, getMarket,
} from 'utils/helpers';
import { ChevronSVG } from 'components/iconsSVG/chevron';
import { i18nContext } from 'context/i18n';

import { IS_CAMPER } from 'utils/constants/system';
import styles from './style.module.css';

const { Option } = Select;

const CamperSelect = ({
  currentShipments, defaultSelectedShipment, market, handleClickShipment,
}) => {
  const { t, locale, profileData } = useContext(i18nContext);
  const [ dropdownVisible, setDropdownVisible ] = useState(false);
  const [ shipments, setShipments ] = useState(currentShipments);

  const marketToUse = getMarket(locale);

  useEffect(() => {
    const marketsToFilter = [ 'AD', 'AT', 'BE', 'CA', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'IE', 'IL', 'IT', 'LT', 'LU', 'LV', 'MC', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SG', 'SI', 'SK', 'US', 'XI' ];
    const previousShipments = [ ...currentShipments ];

    if (marketsToFilter.includes(marketToUse)) {
      if (!(previousShipments.length === 1 && previousShipments[0].id !== '02')) {
        setShipments(previousShipments.filter((item) => item.id !== '02'));
      }
    }
  }, []);

  const renderLabel = (shipment) => {
    if (shipment === 'choose') {
      return (
        <div className={styles.selectShipment} onClick={() => setDropdownVisible(!dropdownVisible)}>
          <p>
            <span>
              {t('bolsa', 'select.an.option')}
            </span>
            <span className={styles.chevronActive}>
              <ChevronSVG />
            </span>
          </p>
        </div>
      );
    }
    return (
      <div className={styles.shipmentWrapper} onClick={() => setDropdownVisible(true)}>
        <p className={styles.selectLabelP}>
          <span>{shipment.name}</span><br/>
          <span className={styles.shipmentBtnDescription} dangerouslySetInnerHTML={{ __html: shipment.text }}></span>
        </p>
        <span className={styles.shipmentPrice}>
          {formatShipmentCost(shipment.shipmentsCostsPrice.shipmentPrice, market, t, shipment.shipmentsCostsPrice.currency)}
          <ChevronSVG />
        </span>
      </div>
    );
  };
  const handleOnSelect = (value) => {
    setDropdownVisible(false);
    handleClickShipment(value);
  };

  if (shipments.length === 1) {
    const shipment = shipments[0];
    return (
      <div className={`${styles.shipmentItem} ${styles.uniqueShipment}`}>
        <p>
          <span>{shipment.name}</span><br/>
          <span className={styles.shipmentBtnDescription} dangerouslySetInnerHTML={{ __html: shipment.text }}></span>
        </p>
        <span>{formatShipmentCost(shipment.shipmentsCostsPrice.shipmentPrice, market, t, shipment.shipmentsCostsPrice.currency)}</span>
      </div>
    );
  }
  return (
    <div className={`${styles.customSelect}`}>
      <Select
        dropdownAlign={{
          offset: [ 0, -2 ],
        }}
        labelInValue={true}
        value={{
          value: defaultSelectedShipment.name,
          label: !dropdownVisible ? renderLabel(defaultSelectedShipment) : renderLabel('choose'),
        }}
        showArrow={false}
        open={dropdownVisible}
        onBlur={() => setDropdownVisible(false)}
        dropdownStyle={{
          padding: 0,
        }}
        dropdownClassName={styles.customSelectDropdown}
        onSelect={(value) => handleOnSelect(value.value)}
      >
        {shipments.map((shipment) => (
          <Option key={shipment.id} value={ shipment.name !== '' ? shipment.name : shipment.text}>
            <div className={styles.shipmentItem}>
              <p>
                <span>{shipment.name}</span><br/>
                <span className={styles.shipmentBtnDescription} dangerouslySetInnerHTML={{ __html: shipment.text }}></span>
              </p>
              <span>{formatShipmentCost(shipment.shipmentsCostsPrice.shipmentPrice, market, t, shipment.shipmentsCostsPrice.currency)}</span>
            </div>
          </Option>
        ))}
      </Select>
    </div>
  );
};

CamperSelect.propTypes = {
  currentShipments: array,
  defaultSelectedShipment: object,
  market: string,
  handleClickShipment: func,
};

export default CamperSelect;
